import { PackageFormData, ProjectFormData } from "Types";

export enum MoveToProjectWizardStep {
  SelectProjectStep,
  SelectPackageStep,
  SoftwareInfoStep,
  OverviewStep,
}

export const WIZARD_STEPS_LABELS: Record<MoveToProjectWizardStep, string> = {
  [MoveToProjectWizardStep.SelectProjectStep]: "Select project",
  [MoveToProjectWizardStep.SelectPackageStep]: "Select package",
  [MoveToProjectWizardStep.SoftwareInfoStep]: "Software info",
  [MoveToProjectWizardStep.OverviewStep]: "Overview",
};

export const DEFAULT_PACKAGE_DATA: PackageFormData = {
  package_name: "",
  package_description: "",
} as const;

export const DEFAULT_PROJECT_DATA: ProjectFormData = {
  project_name: "",
  project_description: "",
} as const;

export const WIZARD_TITLE_LOCATOR_REGEX = /move .+ to project/i;
